import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogicUnsellected = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "512.000000pt",
	height: "512.000000pt",
	viewBox: "0 0 512.000000 512.000000",
	preserveAspectRatio: "xMidYMid meet",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
		fill: "#000000",
		stroke: "none",
		children: /* @__PURE__ */ _jsx("path", { d: "M1848 3499 c-17 -9 -18 -42 -18 -454 l0 -445 -509 0 c-450 0 -511 -2 -525 -16 -20 -19 -20 -29 0 -48 14 -14 75 -16 525 -16 l509 0 0 -445 c0 -437 0 -444 20 -455 18 -10 126 50 810 444 l789 456 435 0 c425 0 436 0 446 20 8 14 8 26 0 40 -10 20 -21 20 -446 20 l-435 0 -781 451 c-429 248 -785 452 -792 454 -6 3 -19 0 -28 -6z m791 -524 c391 -225 711 -412 711 -415 0 -5 -1410 -821 -1431 -828 -5 -2 -9 308 -9 828 0 520 4 830 9 828 6 -1 330 -187 720 -413z" })
	})
});
export default SvgLogicUnsellected;
